import { NO_USER_USER_ID } from '../constants';
import { useLocalStorage } from '../util/localStorage';
import { LocalStorageKey } from '../util/LocalStorageKey';

export function useIsLoggedIn() {
  const token = useLocalStorage(LocalStorageKey.token);
  const userId = useLocalStorage(LocalStorageKey.userId);
  return !!token && userId !== null && userId !== NO_USER_USER_ID;
}
